<template>
  <div class="inputs" ref="inputs" style="width: 100%">
    <div>
      <Fe-file
        v-model="inputVal"
        :name="inputName"
        :permission="permission"
        :size="size"
        :limit="limits"
        :validate="inputValidate"
        :multiple="multiple"
        :accept="acceptFile"
        :propConfList="propConfList"
        :actionUrl="actionUrl"
        :header="header"
        :beforeUpload="beforeAvatarUpload"
        :displayType="displayType ? displayType : 'table'"
        :onSuccess="onSuccess"
        :inputWriteable="inputWriteable"
        ref="upload"
        @download="download"
        @preview="preview"
        @input="$emit('input', inputVal)"
      />
      <!-- @before-upload="beforeAvatarUpload" -->
      <!-- 预览压缩文件-->
      <FeFilePreview ref="filePreview" />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import utils from "@/utils.js";
import req from "@/request.js";
import FeFilePreview from "@/components/common/FeFilePreview.vue";
import { Message } from "element-ui";
export default {
  name: "eip-attachment",
  components: { FeFilePreview },
  props: [
    "validate",
    "value",
    "name",
    "permission",
    "size",
    "limit",
    "multiple",
    "accept",
    "propConf",
    "displayType",
    "configAttributes",
    "tenantId"
  ],
  data() {
    return {
      propConfList: [],
      inputVal: this.value,
      src: "",
      fileId: "",
      fileTree: "",
      iframeSrc: "",
      acceptFile: "",
      newValidate: null,
      inputWriteable: true
    };
  },
  computed: mapState({
    inputValidate: function () {
      if (this.newValidate) {
        return this.newValidate;
      }
      var validateObj = this.$store.state.index.validate;
      return utils.addRequiredOrNot(
        this.permission,
        this.validate,
        validateObj,
        this
      );
    },
    header: (state) => {
      return { Authorization: `Bearer ${state.login.currentUser.token}` };
    },
    actionUrl: function () {
      if (this.tenantId) {
        return (
          req.getContext().portal +
          "/system/file/v1/upload?tenantId=" +
          this.tenantId
        );
      } else {
        return req.getContext().portal + "/system/file/v1/upload";
      }
    },
    inputName: function () {
      let labeldesc = "";
      if (
        this.$slots &&
        this.$slots.labeldesc &&
        this.$slots.labeldesc[0].children &&
        this.$slots.labeldesc[0].children[0].text
      ) {
        labeldesc = this.$slots.labeldesc[0].children[0].text;
        return this.name ? this.name : utils.getName() + "-" + labeldesc;
      } else {
        return this.name ? this.name : utils.getName();
      }
    },
    limits() {
      if (this.limit) {
        return Number(this.limit);
      } else {
        return 1;
      }
    }
  }),
  mounted() {
    if (this.configAttributes) {
      if (this.configAttributes.isInputEdit) {
        this.inputWriteable = !this.configAttributes.isInputEdit;
      } else {
        this.inputWriteable = true;
      }
    } else {
      this.inputWriteable = true;
    }
    if (this.permission == "r") {
      this.inputWriteable = false;
    }
    this.$forceUpdate()
  },
  watch: {
    value: function (n, v) {
      this.inputVal = n;
    }
  },
  beforeDestroy() {},
  destroyed() {},
  created() {
    if (this.propConf) {
      let list = JSON.parse(this.propConf);
      list.forEach((element) => {
        if (element.desc) {
          if (element.requried) {
            element.inputValidate = "required:true";
          }
          this.propConfList.push(element);
        }
      });
    }
    if (this.accept) {
      this.acceptFile = "." + this.accept.split(",").join(",.");
    }
    // this.$validator = this.$root.$validator;
  },
  methods: {
    onSuccess(file) {},
    beforeAvatarUpload(file) {
      // 文件类型限制
      const name = file.name ? file.name : "";
      const ext = name
        ? name.substr(name.lastIndexOf(".") + 1, name.length)
        : true;
      const isExt = this.accept.indexOf(ext) < 0;
      if (isExt) {
        if (this.accept == "" || this.accept == undefined) {
          this.$message.error("请配置可上传文件的格式!");
        } else {
          this.$message.error("上传的附件只能是 " + this.accept + "格式!");
        }
      }
      return !isExt;
    },
    download(file) {
      if (!file.response && !file.response.value) {
        this.$message.warning("请稍后再试！");
        return;
      }
      req.download(
        "${portal}/system/file/v1/downloadFile?fileId=" + file.response.fileId
      );
    },
    preview(files) {
      if (!files.response) {
        this.$message.warning("请稍后再试！");
        return;
      }
      var fileData = files.response;
      var id = fileData.fileId;
      let obj = {};
      obj.id = fileData.fileId;
      obj.name = fileData.fileName;
      obj.size = fileData.size;
      this.$refs.filePreview.preview(obj);
    }
  }
};
</script>
<style lang="stylus" scoped>
div[aria-invalid='true'] >>> .el-input__inner, div[aria-invalid='true'] >>> .el-input__inner:focus {
  border-color: #f56c6c;
}
</style>
